// La response de `/TurnoWeb/Productos` tiene dos shapes:
//  - flujo publico: array plano de productos → sin `unidad`.
//  - con token (`?t=`): `{ producto: [...], unidad, anexoId, usuario }`.
// Esta helper devuelve `unidad` solo cuando es un numero (incluido 0); en
// cualquier otro caso (array, undefined, string, null) devuelve null.
export function extractProductosUnidad(data: unknown): number | null {
  if (Array.isArray(data) || !data || typeof data !== 'object') return null;
  const unidad = (data as { unidad?: unknown }).unidad;
  return typeof unidad === 'number' ? unidad : null;
}

// Regla de negocio: solo omitimos el step "sucursal" cuando el back fijo
// una unidad concreta (!= 0). Con `unidad: 0` (o sin unidad), el user
// elige sucursal como en el flujo publico.
export function shouldOmitSucursal(unidad: number | null | undefined): boolean {
  return typeof unidad === 'number' && unidad !== 0;
}
